// Dolores's Ledger pages (docs/06 §5). Found as rare draft options; picking one adds no symbol.
// Text lives in i18n as `ledger.<id>`. Pages 1–7 turn up in Act II, 8–13 once the machine can see (Act III).
export interface LedgerPage {
  id: string;
  /** Only found once this feature is unlocked ('face' = Act II, 'eyes' = Act III). */
  act: 'face' | 'eyes';
}

export const LEDGER_PAGES: LedgerPage[] = Array.from({ length: 13 }, (_, i) => ({
  id: `ledger_${String(i + 1).padStart(2, '0')}`,
  act: i < 7 ? 'face' : 'eyes',
}));

export const PAGE_PREFIX = 'page:';
